export default __webpack_public_path__ + "images/NQ.c3d9a4a.png";